export default [
  'image/jpeg',
  'image/pjpeg',
  'image/png',
  'image/gif',
  'image/bmp',
  'text/plain',
  'text/xml',
  'application/pdf',
  'application/vnd.mspowerpoint',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.oasis.opendocument.spreadsheet',
];



// WEBPACK FOOTER //
// ./FrontEnd/js/tipos-arquivos-upload.js